
import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import icons from './icons.js';

registerBlockType(metadata.name, {
	icon: icons.doDontCards,
	category: 'custom-c4l-category',
	attributes: {
		contentDo: {
			type: 'string',
		},
		contentDont: {
			type: 'string',
		}
	},
	edit: Edit,
	save
});
